<script>
export default {
  name: 'Report',
  props: {
    report: { type: String, required: true },
    formType: { type: String }
  }
}
</script>

<template>
  <GraphQLFormSearch
    :formType="formType || `_REPORT_${report}`"
    searchType="report"
  />
</template>
